export default function Logo({ size = 24, showText = true }) {
  return (
    <div className="flex items-center gap-2" data-testid="app-logo">
      <div
        className="relative shrink-0"
        style={{ width: size, height: size }}
        aria-label="MyResumeDesign logo"
      >
        {/* Blue paper */}
        <div
          className="absolute inset-0 bg-[#2400FF]"
          style={{ clipPath: "polygon(0 0, 100% 0, 100% 78%, 78% 100%, 0 100%)" }}
        />
        {/* Fold */}
        <div
          className="absolute bg-white"
          style={{
            right: 0,
            bottom: 0,
            width: "34%",
            height: "34%",
            clipPath: "polygon(0 0, 100% 100%, 0 100%)",
          }}
        />
        {/* Red mark */}
        <div
          className="absolute bg-[#FF2A00]"
          style={{ right: "6%", top: "6%", width: "32%", height: "10%" }}
        />
      </div>
      {showText && (
        <span className="font-heading font-bold text-base tracking-tight leading-none">
          MyResumeDesign
        </span>
      )}
    </div>
  );
}
